import { useMediaQuery } from "react-responsive";

export const min_xs = { query: "(min-width: 0px)" };
export const min_sm = { query: "(min-width: 576px)" };
export const min_md = { query: "(min-width: 768px)" };
export const min_lg = { query: "(min-width: 992px)" };
export const min_xl = { query: "(min-width: 1200px)" };
export const min_xxl = { query: "(min-width: 1400px)" };

export const max_xs = { query: "(max-width: 0px)" };
export const max_sm = { query: "(max-width: 576px)" };
export const max_md = { query: "(max-width: 768px)" };
export const max_lg = { query: "(max-width: 992px)" };
export const max_xl = { query: "(max-width: 1200px)" };
export const max_xxl = { query: "(min-width: 1400px)" };

export interface UseMediaType {
  min: {
    xs: boolean;
    sm: boolean;
    md: boolean;
    lg: boolean;
    xl: boolean;
    xxl: boolean;
  };
  max: {
    xs: boolean;
    sm: boolean;
    md: boolean;
    lg: boolean;
    xl: boolean;
    xxl: boolean;
  };
}

const useMedia = () => {
  const minxs = useMediaQuery(min_xs);
  const minsm = useMediaQuery(min_sm);
  const minmd = useMediaQuery(min_md);
  const minlg = useMediaQuery(min_lg);
  const minxl = useMediaQuery(min_xl);
  const minxxl = useMediaQuery(min_xxl);

  const maxxs = useMediaQuery(max_xs);
  const maxsm = useMediaQuery(max_sm);
  const maxmd = useMediaQuery(max_md);
  const maxlg = useMediaQuery(max_lg);
  const maxxl = useMediaQuery(max_xl);
  const maxxxl = useMediaQuery(max_xxl);

  return {
    min: {
      xs: minxs,
      sm: minsm,
      md: minmd,
      lg: minlg,
      xl: minxl,
      xxl: minxxl,
    },
    max: {
      xs: maxxs,
      sm: maxsm,
      md: maxmd,
      lg: maxlg,
      xl: maxxl,
      xxl: maxxxl,
    },
  };
};

export default useMedia;
